import { formatIsoToDisplay } from '@/utils/dateFormatter';

interface DateTimeObjectProps {
  value: string;
}

export const DateTimeObject = ({ value }: DateTimeObjectProps) => (value ? formatIsoToDisplay(value) : null);
